var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAffirmIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    viewBox: "0 0 32 33",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27532_2329)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_27532_2329)"
  }, /*#__PURE__*/React.createElement("mask", {
    style: {
      maskType: "luminance"
    },
    height: 17,
    id: "mask0_27532_2329",
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 4,
    y: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3132 7.14502H4.66797V23.7462H27.3132V7.14502Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27532_2329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36355 23.4536C7.42313 22.0209 6.8752 20.3111 6.8752 18.4729C6.8752 13.4522 10.9594 9.36795 15.9802 9.36795C21.001 9.36795 25.0852 13.4522 25.0852 18.4729C25.0852 20.3098 24.536 22.0209 23.5969 23.4536H26.1461C26.8857 21.9497 27.3028 20.2593 27.3028 18.4729C27.3028 12.2294 22.2238 7.15161 15.9815 7.15161C9.73921 7.15161 4.66016 12.2307 4.66016 18.4729C4.66016 20.2593 5.07726 21.9497 5.8169 23.4536H8.36355Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1328 13.0933C14.4747 13.0933 12.5667 13.8744 11.5304 14.7008L12.476 16.6917C13.3063 15.9314 14.6496 15.2824 15.8608 15.2824C17.0123 15.2824 17.6471 15.6671 17.6471 16.443C17.6471 16.9651 17.2248 17.2591 16.4294 17.3316C13.4424 17.6063 11.1211 18.5389 11.1211 20.8317C11.1211 22.6503 12.432 23.7488 14.5887 23.7488C16.0318 23.7488 17.1652 22.947 17.7766 21.8887V23.4522H20.4658V16.899C20.4671 14.193 18.5849 13.0933 16.1328 13.0933ZM15.3478 21.6477C14.476 21.6477 13.9981 21.2747 13.9981 20.662C13.9981 19.3848 15.559 19.0765 17.5914 19.0765C17.5914 20.4133 16.6963 21.6477 15.3478 21.6477Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27532_2329"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 24,
    transform: "translate(4 3.5)",
    width: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_27532_2329"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 16.71,
    transform: "translate(4.66797 7.14502)",
    width: 22.6686
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirmIcon);
export default __webpack_public_path__ + "static/media/AffirmIcon.702413fe5b9f3936780dc428fbf421f0.svg";
export { ForwardRef as ReactComponent };